import { Directive, ElementRef, Renderer2, OnInit, DestroyRef, inject } from '@angular/core';
import { fromEvent } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Directive({
  selector: '[tsFocusBgColor]',
  standalone: true,
})
export class FocusBackgroundColorDirective implements OnInit {
  private readonly destroyRef = inject(DestroyRef);
  private focusColorClass = 'bg-blue-100';

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit() {
    fromEvent(document, 'focusin')
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        if (this.el.nativeElement.contains(document.activeElement)) {
          this.renderer.addClass(this.el.nativeElement, this.focusColorClass);
        } else {
          this.renderer.removeClass(this.el.nativeElement, this.focusColorClass);
        }
      });
  }
}
